import {
  AppBar,
  Button,
  IconButton,
  Toolbar,
  Avatar,
  Grid,
  Badge,
  useTheme,
  Popper,
  Grow,
  Menu,
  MenuItem,
  Typography,
  Hidden,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import MenuIcon from "@material-ui/icons/Menu";
import clsx from "clsx";
import useStyles from "./HeaderBar.css";
import { useHistory, useLocation } from "react-router-dom";
import translation from "../../i18n/i18.json";
import {
  InforDisplyaDuration,
  NavigationPaths,
  NOTIFICATIONS_REFRESH_INTERVAL,
  VendorForm1Modes,
  VendorRequestViewMode,
} from "../../constants/AppConstants";
import { PublicClientApplication } from "@azure/msal-browser";
import { authConfig } from "../../utils/AuthConfig";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../reducers";
import { UserLoginState } from "../../reducers/LoginReducer";
import { Common } from "../../utils/Common";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { Link } from "react-router-dom";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import SearchIcon from "@material-ui/icons/SearchRounded";
import PeopleOutlinedIcon from "@material-ui/icons/PeopleOutlined";
import { VendorCreationActions } from "../../actions/vendor/VendorCreationAction";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { RoleUtil } from "../../utils/RoleUtil";
import NotificationBar from "../NotificationBar/NotificationBar";
import { AppNotification } from "../../models/Notification/AppNotification";
import { NotificationService } from "../../services/NotificationService";
import { ResponseObject } from "../../models/ResponseObject";
import AllActions from "../../actions";
import useInterval from "../../customHooks/useInterval";
import VendorSelectDialog from "../../components/Vendor/Popup/VendorSelectDialog";
import { SAPVendor } from "../../models/SAPVendor";

const msaObj = new PublicClientApplication(authConfig);

export default function HeaderBar(props: any) {
  const classes = useStyles();
  let location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const history = useHistory();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  //const [isMenuOpen, setisMenuOpen] = React.useState(false);
  const { isMenuOpen, setisMenuOpen, setNofityRequestNumber } = props;
  const loginUser = useSelector<RootState, UserLoginState>(
    (state) => state.loginDetails
  );

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [notifybarEl, setNotifybarEl] =
    React.useState<HTMLButtonElement | null>(null);
  const [notificationList, setNotificationList] = React.useState(Array<AppNotification>());
  const notifyBtnRef = React.useRef<HTMLButtonElement | null>(null);
  const [notificationCount, setNotificationCount] = useState(0);
  //SAP vendor select popup
  const [openVendorSelectDialog, setOpenVendorSelectDialog] = useState(false);
  const [vendorSelectMode, setVendorSelectMode] = useState(VendorRequestViewMode.VendorCreate);
  const isTestSystem = process.env.REACT_APP_TEST_ENV;

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(
            message,
            InforDisplyaDuration.common
          )
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(
            message,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };

  const handleDrawerOpen = () => {
    if (!Common.isVendor()) {
      setisMenuOpen(true);
    }
  };

  const handleDrawerClose = () => {
    setisMenuOpen(false);
  };

  const handleSignOut = () => {
    if (!Common.isVendor()) {
      const logoutRequest = {
        account: msaObj.getAccountByUsername(loginUser.userName)!,
      };
      msaObj.logoutPopup(logoutRequest);
      Common.clearLocalStorage();
    } else {
      Common.clearLocalStorage();
      history.replace(NavigationPaths.VendorLogout);
    }
  };

  const handleAddVendor = () => {
    dispatch(VendorCreationActions.resetRequestDetails(loginUser.userName));
    history.push(NavigationPaths.VendorRequest, {
      mode: VendorForm1Modes.VendorInitialCreate,
    });
  };

  const onSapVendorSearchPress = () => {
    history.push(NavigationPaths.SapVendorSearch, {
      isEditmode: true,
    });
  };

  const onSelectVendorPopupClose = (e: any) => {
    setOpenVendorSelectDialog(false);
    setVendorSelectMode(VendorRequestViewMode.VendorCreate);
  };

  const onSapVendorSelect = (sapVendorList: Array<SAPVendor>) => {
    if (sapVendorList && sapVendorList.length == 1) {
      setOpenVendorSelectDialog(false);
      let sapVendor  = sapVendorList[0];
    } else {
        dispatch(AllActions.infoActions.openInforWarn(translation.vendordetail_vendor_select_popup_nodata_msg,InforDisplyaDuration.common));
    }
  };

  useEffect(() => {
    if (notificationList && notificationList.length > 0) {
      setNotifybarEl(notifyBtnRef.current);
    } else {
      setNotifybarEl(null);
    }
  }, [notificationList]);

  const handleNotifications = (event: any) => {
    //setNotifybarEl(event.currentTarget);
    //setNotificationList();
    //let target = event.currentTarget;
    prepareForRequest();
    NotificationService.GetHeaderNotificationList(
      (noticationList: Array<AppNotification>) => {
        if (noticationList) {
          compeleteRequest(true);
          setNotificationList(noticationList);
        } else {
          compeleteRequest(false, translation.header_notifications_error);
        }
      },
      (error) => {
        compeleteRequest(false, translation.header_notifications_error);
      }
    );
  };

  const hadleClickOnNotification = (notication: AppNotification) => {
    setAnchorEl(null);
    prepareForRequest();
    NotificationService.readNotification(
      notication.id,
      function (readNotifyData: ResponseObject) {
        console.log(readNotifyData);
        compeleteRequest(true);
      },
      function (error: Error) {
        console.log(error);
        compeleteRequest(false);
      }
    );
  };

  const handleExpandMore = (event: any) => {
    if (matches) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleMoreToolbarClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const getNotificationsCount = () => {
    NotificationService.readNotificationsCount(
      (notifictaionCount: number) => {
        if (notifictaionCount) {
          setNotificationCount(notifictaionCount);
        }
      },
      (error) => {}
    );
  };

  useInterval(() => {
    if (!Common.isVendor()) {
      getNotificationsCount();
    }
  }, NOTIFICATIONS_REFRESH_INTERVAL);

  return (
    <div>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: isMenuOpen,
        })}
      >
        <Toolbar>
          <div>
            <IconButton
              onClick={handleDrawerOpen}
              edge="start"
              color="inherit"
              className={clsx(classes.menuButton, {
                [classes.hide]: isMenuOpen,
              })}
            >
              <MenuIcon></MenuIcon>
            </IconButton>
          </div>

          {
            <Hidden smDown>
              <div className={classes.innerLogo}></div>
            </Hidden>
          }

          {
            <Hidden smDown>
              {" "}
              <div className={classes.AppName}>
                Vendor <b>Onboarding</b>{" "}
              </div>
              {isTestSystem === "Y" && (<div className={classes.AppEnv}>
                <b>{Common.getSapSystem() == "S4" ? "S4HANA Testing" : "DARWIN(ECC) Testing"}</b>{" "}
              </div>)}
            </Hidden>
          }

          <div className={classes.actData}>
            <div className={classes.headerMid}>
              {RoleUtil.isRequestor() && (
                <div className={classes.addVendorBtn}>
                  <button onClick={handleAddVendor}>
                    <AddCircleIcon></AddCircleIcon>
                    {
                      <Hidden smDown>
                        {" "}
                        <span className={classes.addVendorBtnTxt}>
                          {translation.toolbar_add_vndr_btn_text}
                        </span>
                      </Hidden>
                    }
                  </button>
                </div>
              )}
              {RoleUtil.isRequestor() && (
                <div className={classes.addVendorBtn}>
                  <button onClick={onSapVendorSearchPress}>
                    <SearchIcon></SearchIcon>
                    {
                      <Hidden smDown>
                        {" "}
                        <span className={classes.addVendorBtnTxt}>
                          {translation.toolbar_search_vndr_btn_text}
                        </span>
                      </Hidden>
                    }
                  </button>
                </div>
              )}
              {/* {RoleUtil.isRequestor() && (
                <div className={classes.addVendorBtn}>
                  <button onClick={() => onSapVendorSearchPress(VendorRequestViewMode.VendorBlock)}>
                    <AddCircleIcon></AddCircleIcon>
                    {
                      <Hidden smDown>
                        {" "}
                        <span className={classes.addVendorBtnTxt}>
                          {translation.toolbar_block_vndr_btn_text}
                        </span>
                      </Hidden>
                    }
                  </button>
                </div>
              )}
              {RoleUtil.isRequestor() && (
                <div className={classes.addVendorBtn}>
                  <button onClick={() => onSapVendorSearchPress(VendorRequestViewMode.VendorExtend)}>
                    <AddCircleIcon></AddCircleIcon>
                    {
                      <Hidden smDown>
                        {" "}
                        <span className={classes.addVendorBtnTxt}>
                          {translation.toolbar_extend_vndr_btn_text}
                        </span>
                      </Hidden>
                    }
                  </button>
                </div>
              )} */}
            </div>

            <div className={classes.headerRight}>
              {!Common.isVendor() && (
                <Badge
                  color="secondary"
                  badgeContent={notificationCount}
                  showZero
                  className={classes.alertwrapper}
                >
                  <button onClick={handleNotifications} ref={notifyBtnRef}>
                    <NotificationsNoneIcon></NotificationsNoneIcon>
                  </button>
                </Badge>
              )}

              {
                <Hidden smDown>
                  <div className={classes.logout}>
                    <div className={classes.logOutBtnWrapper}>
                      <Button onClick={handleSignOut}>
                        <ExitToAppIcon></ExitToAppIcon>
                      </Button>
                    </div>
                  </div>
                </Hidden>
              }
              <Avatar
                className={classes.avatarCls}
                alt="Lavangi Abhayaratna"
                onClick={handleExpandMore}
              />

              <div className={classes.userName}>
                <span className={classes.userNameTxt}>
                  {<Hidden smDown>{loginUser.userName}</Hidden>}
                </span>
              </div>
            </div>
          </div>
          <div>
            <Menu
              id="more-toolbar-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMoreToolbarClose}
              className={classes.menuWrapper}
            >
              <MenuItem onClick={handleMoreToolbarClose}>
                {/* {translation.main_toolbar_user_settings} */}
                <Typography>
                  <div className={classes.userName}>
                    <span className={classes.userNameTxt}>
                      {loginUser.userName}
                    </span>
                    {/* <span className={classes.title}> Manager</span> */}
                  </div>
                </Typography>
              </MenuItem>
              <MenuItem onClick={handleSignOut}>
                {/* {translation.main_toolbar_user_logout} */}
                <div className={classes.logOutBtnWrapperDrop}>
                  <Button onClick={handleSignOut}>Logout</Button>
                </div>
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <NotificationBar
        setNofityRequestNumber={setNofityRequestNumber}
        anchorEl={notifybarEl}
        setAnchorEl={setNotifybarEl}
        notificationList={notificationList}
        clickOnItem={hadleClickOnNotification}
      ></NotificationBar>
      <VendorSelectDialog
        open={openVendorSelectDialog}
        title={translation.vendordetail_vendor_select_popup_title}
        handleClose={onSelectVendorPopupClose}
        isEditmode={true}
        onUpdateConfirm={onSapVendorSelect}
        alreadySelectedVendors={[]}
        nodataMsg={translation.vendordetail_vendor_select_popup_nodata_msg}
        maxSelectItems={1}
        requestMode={vendorSelectMode}
      ></VendorSelectDialog>
    </div>
  );
}
